<template>
    <div class="relative items-center justify-center w-full overflow-hidden lg:pt-40 lg:pb-40 xl:pt-40 xl:pb-64">
        <div
            class="container flex flex-col items-center justify-between h-full max-w-6xl px-8 mx-auto -mt-32 lg:flex-row xl:px-0">
            
            <div
                class="z-30 flex flex-col items-center w-full max-w-xl pt-48 text-center lg:items-start lg:w-1/2 lg:pt-20 xl:pt-40 lg:text-left">
                <h1 class="relative mb-4 text-3xl font-black leading-tight text-gray-900 sm:text-6xl xl:mb-8">
                    Tail-Wagging Treats & Trendy Gear</h1>
                <p class="pr-0 mb-8 text-base text-gray-600 sm:text-lg xl:text-xl lg:pr-20">For the Paws that Deserve
                    the Best</p>
                <router-link to="/store"
                    class="relative self-start inline-block w-auto px-8 py-4 mx-auto mt-0 text-base font-bold text-white bg-orange-600 border-t border-gray-200 rounded-md shadow-md hover:shadow-2xl duration-200 hover:scale-150 sm:mt-1 fold-bold lg:mx-0">Shop
                    Now!</router-link>

                <!-- integrates -->
                <div class="flex-col mt-12 sm:flex lg:mt-24">
                    <p class="mb-4 text-sm font-medium tracking-widest text-gray-500 uppercase">Visit Us to</p>
                    <div href="#" class="flex lg:w-96">
                    
                        <div
                            class="mr-4 text-gray-500 duration-150 cursor-pointer fill-current transition-color hover:text-gray-600 flex flex-col justify-center">
                            <svg class="h-10 w-14" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                <g stroke="none" stroke-width="1">
                                    <g>
                                        <path
                                            d="M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z" />
                                    </g>
                                </g>
                            </svg>
                            <p class="font-bold">Adopt</p>
                        </div>
                        <div
                            class="mr-4 text-gray-500 duration-150 cursor-pointer fill-current transition-color hover:text-gray-600 flex flex-col justify-center">
                            <svg class="h-10 w-14" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                <g stroke="none" stroke-width="1">
                                    <g>
                                        <path
                                            d="M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z" />
                                    </g>
                                </g>
                            </svg>
                            <p class="font-bold">Feed</p>
                        </div>
                        <div
                            class="mr-4 text-gray-500 duration-150 cursor-pointer fill-current transition-color hover:text-gray-600 flex flex-col justify-center">
                            <svg class="h-10 w-14" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                <g stroke="none" stroke-width="1">
                                    <g>
                                        <path
                                            d="M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z" />
                                    </g>
                                </g>
                            </svg>
                            <p class="font-bold">Protect</p>
                        </div>
                        
                        
                        

                    </div>
                </div>
            </div>

            <div class="relative z-10 flex flex-col items-end justify-center w-full h-full lg:w-1/2 ms:pl-10">
                <div class="container relative left-0 w-full max-w-4xl lg:absolute xl:max-w-6xl lg:w-screen">
                    <img src="https://firebasestorage.googleapis.com/v0/b/webohmydog.appspot.com/o/pets%2FCharlie.jpg?alt=media&token=d3a2b258-8f61-4e05-a127-5f8034cad7ea"
                        class="w-full h-auto mt-20 mb-20 ml-0 lg:mt-24 xl:mt-40 lg:mb-0 lg:h-full lg:-ml-12 rounded-3xl">
                </div>
            </div>

        </div>
    </div>
    <HealthTips />
</template>

<script>
import HealthTips from '@/components/HealthTips.vue'

export default {
    name: 'HeroSection',
    components: {
        HealthTips
    },
    props: {}
};
</script>

<style scoped>
body {
    overflow-y: hidden;
}
</style>